/* AH FAST PIP LANDING — deferred bundle.
 *
 * Everything here is post-first-paint work. The variant controller and add-to-cart live
 * inline in snippets/ah-pip-boot.liquid instead, because a deferred script binds too
 * late on a cold mobile load and an unbound ATC submit navigates away to /cart.
 *
 * Contents:
 *   1. Cart drawer mutations  (theme.js/global.js own these normally; neither is loaded)
 *   2. Poster -> video swap for the story rows
 *   3. Mobile sticky add-to-cart
 *   4. Size guide popup
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ 1. Drawer --
   * snippets/halo-cart-sidebar.liquid already ships a vanilla openDrawer() and the
   * [data-cart-sidebar] / [data-ah-add] handlers. What it does NOT ship is qty +/-,
   * qty edit, remove and close: theme.js binds those with jQuery ($doc.on +
   * Shopify.removeItem) and global.js defines <cart-update-quantity>. Rebound here.
   *
   * Line addressing resolves against the live cart on every click. Nothing the
   * drawer rendered with survives a cart change: removing a line renumbers every
   * data-index after it, and on carts carrying the belt set deal Shopify
   * re-hashes every remaining item.key too. Sending either stale value gets a
   * 422 back, and the row then looks dead — which is what shoppers reported.
   */
  var DRAWER = '#halo-cart-sidebar';

  function closeDrawer() {
    document.body.classList.remove('cart-sidebar-show');
  }

  function refreshDrawer() {
    return Promise.all([
      fetch('/cart?view=ajax_side_cart&_=' + Date.now()).then(function (r) { return r.text(); }),
      fetch('/cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var w = document.querySelector(DRAWER + ' .previewCart-wrapper');
      if (w) w.innerHTML = res[0];
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (n) {
        n.textContent = res[1].item_count;
      });
      return res[1];
    });
  }

  /* Size labels in the drawer.
   * A Shopify market localization strips the cm from Pip's size values ("XS-75" -> "XS"),
   * so the drawer would read "Cognac / M". snippets/ah-pip-size-labels.liquid fixes this
   * store-wide with a MutationObserver on document.body {subtree:true} — that is the same
   * document-wide churn that got lazysizes removed from this theme, so it is not rendered
   * on this page.
   *
   * Instead: build the map FROM the rendered labels (every label is "<RAW>-<cm>" and RAW
   * never contains a hyphen), and re-run only on the two nodes that actually change.
   * Self-disabling — once the localization is fixed the raw values already carry the cm,
   * so nothing in the map matches and this is a no-op.
   */
  var PIPD = null, SIZE_MAP = null, PID = null;
  try { PIPD = JSON.parse(document.getElementById('pipf-data').textContent); } catch (e) {}
  if (PIPD && PIPD.s) {
    SIZE_MAP = {};
    PID = String(PIPD.pid || '');
    PIPD.s.forEach(function (label) {
      var cut = label.lastIndexOf('-');
      if (cut > 0) SIZE_MAP[label.slice(0, cut)] = label;
    });
  }

  function fixSizeLabels() {
    if (!SIZE_MAP) return;
    function patchTail(el) {
      if (!el) return;
      var parts = (el.textContent || '').trim().split(' / ');
      var last = parts[parts.length - 1];
      if (Object.prototype.hasOwnProperty.call(SIZE_MAP, last)) {
        parts[parts.length - 1] = SIZE_MAP[last];
        el.textContent = parts.join(' / ');
      }
    }
    // Drawer line rows — scoped to Pip lines only, so other belts in the cart are untouched.
    Array.prototype.forEach.call(document.querySelectorAll(DRAWER + ' .previewCartItem'), function (row) {
      if (PID && !row.querySelector('[data-product="' + PID + '"]')) return;
      patchTail(row.querySelector('.previewCartItem-variant'));
    });
    // Set-widget and drawer-upsell option lists.
    Array.prototype.forEach.call(
      document.querySelectorAll('.ah-pip-bundle__size option, .ah-cart-upsell__variant option, .ah-cart-upsell__size option'),
      function (o) {
        var t = (o.textContent || '').trim();
        if (Object.prototype.hasOwnProperty.call(SIZE_MAP, t)) { o.textContent = SIZE_MAP[t]; return; }
        patchTail(o);
      }
    );
  }

  // One observer per changing node, childList only — not document.body {subtree:true}.
  // Covers every path that rewrites the drawer: our ATC, ah-pip-colour-bundle's add,
  // the [data-ah-add] upsell, and halo-cart-sidebar's own openDrawer().
  function watch(node) {
    if (!node) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(fixSizeLabels, 40);
    }).observe(node, { childList: true });
  }
  watch(document.querySelector(DRAWER + ' .previewCart-wrapper'));
  watch(document.getElementById('ah-pip-bundle'));
  fixSizeLabels();

  // Look the row up in the cart as it is right now. The rendered key is only a
  // hint: its "<variantId>:<hash>" prefix still identifies the variant even
  // after Shopify re-hashes the line. Resolves to null when the line is gone.
  function resolveLineKey(staleKey, index) {
    if (!staleKey) return Promise.resolve(null);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].key === staleKey) return staleKey;
        }
        var vid = staleKey.split(':')[0];
        var matches = items.filter(function (it) {
          return String(it.variant_id || it.id) === vid;
        });
        if (matches.length === 1) return matches[0].key;
        if (matches.length > 1) {
          // Several lines of the same variant: prefer the one where the shopper clicked.
          var at = items[parseInt(index, 10) - 1];
          if (at && String(at.variant_id || at.id) === vid) return at.key;
          return matches[0].key;
        }
        return null;
      })
      .catch(function () { return staleKey; });
  }

  var mutating = false;
  function changeLine(row, qty) {
    if (mutating || !row) return;
    var key = row.getAttribute('data-line');
    var line = row.getAttribute('data-index');
    if (!key && !line) return;
    mutating = true;
    var wrap = document.querySelector(DRAWER + ' .previewCart-wrapper');
    if (wrap) wrap.style.opacity = '.55';

    resolveLineKey(key && key.indexOf(':') > 0 ? key : null, line)
      .then(function (currentKey) {
        // Line already gone - fall through to the refresh so the row clears.
        if (key && !currentKey) return null;
        var body = currentKey ? { id: currentKey, quantity: qty }
                              : { line: parseInt(line, 10), quantity: qty };
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .catch(function () {})
      // Refresh after a failure too. A drawer left out of step with the cart is
      // the one state a shopper cannot click their way out of.
      .then(function () { return refreshDrawer(); })
      .catch(function () {})
      .then(function () {
        mutating = false;
        var w2 = document.querySelector(DRAWER + ' .previewCart-wrapper');
        if (w2) w2.style.opacity = '';
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-close-cart-sidebar]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('.background-overlay') && document.body.classList.contains('cart-sidebar-show')) {
      closeDrawer(); return;
    }

    var rm = t.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(rm, 0); return; }

    var minus = t.closest('[data-minus-quantity-cart]');
    var plus = t.closest('[data-plus-quantity-cart]');
    if (minus || plus) {
      e.preventDefault();
      var box = (minus || plus).closest('.previewCartItem-qty');
      var input = box && box.querySelector('[data-cart-quantity]');
      if (!input) return;
      var n = parseInt(input.value, 10) || 1;
      n = plus ? n + 1 : n - 1;
      if (n < 0) n = 0;
      changeLine(input, n);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest ? e.target.closest('[data-cart-quantity]') : null;
    if (!input || !input.closest(DRAWER)) return;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    changeLine(input, n);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('cart-sidebar-show')) closeDrawer();
  });

  /* --------------------------------------------------------- 2. Story row video --
   * The poster is a real lazy <img> in an aspect-ratio box, not a <video poster>
   * attribute: Chrome fetches a poster attribute eagerly even with preload="none",
   * and an element with no layout box ignores loading="lazy" entirely.
   * The <video> element itself is only created once the row is within 600px.
   */
  var vids = Array.prototype.slice.call(document.querySelectorAll('.pipf-vid[data-mp4]'));
  if (vids.length && 'IntersectionObserver' in window) {
    var build = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var box = en.target;
        build.unobserve(box);
        if (box.querySelector('video')) return;
        var v = document.createElement('video');
        // No autoplay attribute: the element is built 600px BEFORE the row is on screen,
        // so autoplay would start playback that the visibility observer immediately
        // pauses ("The play() request was interrupted by a call to pause()").
        // Playback is driven purely by the second observer below.
        v.muted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        v.preload = 'metadata';
        if (box.dataset.webm) {
          var sw = document.createElement('source');
          sw.src = box.dataset.webm; sw.type = 'video/webm'; v.appendChild(sw);
        }
        var sm = document.createElement('source');
        sm.src = box.dataset.mp4; sm.type = 'video/mp4'; v.appendChild(sm);
        v.addEventListener('playing', function () { box.classList.add('is-playing'); }, { once: true });
        box.appendChild(v);
        play.observe(box);
      });
    }, { rootMargin: '600px 0px' });

    var play = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target.querySelector('video');
        if (!v) return;
        if (en.isIntersecting) { try { v.currentTime = 0; v.play(); } catch (err) {} }
        else { try { v.pause(); } catch (err) {} }
      });
    }, { threshold: 0 });

    vids.forEach(function (b) { build.observe(b); });
  }

  /* ------------------------------------------------- 3. Mobile sticky add-to-cart --
   * Replaces sticky-add-to-cart.js (44KB). Shows once the real ATC scrolls out of view.
   */
  var realAtc = document.getElementById('product-add-to-cart');
  if (realAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        document.body.classList.toggle('pipf-atc-stuck', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(realAtc);
  }

  /* ------------------------------------------------------------- 4. Size guide --
   * The chart is a 1080x5400 PNG (274KB). It ships as data-src with no src and is
   * assigned on first open only; the wrapper carries the aspect ratio so there is
   * no shift when it lands.
   */
  var sg = document.getElementById('pipf-sizeguide');
  if (sg) {
    var sgImg = sg.querySelector('img[data-src]');
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-pipf-sizeguide]')) {
        e.preventDefault();
        if (sgImg && !sgImg.getAttribute('src')) sgImg.setAttribute('src', sgImg.getAttribute('data-src'));
        sg.hidden = false;
        document.body.classList.add('pipf-sg-open');
        return;
      }
      if (t.closest('[data-pipf-sizeguide-close]') || t === sg) {
        sg.hidden = true;
        document.body.classList.remove('pipf-sg-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sg.hidden) { sg.hidden = true; document.body.classList.remove('pipf-sg-open'); }
    });
  }
})();
